import { createRoot } from 'react-dom/client';

// third party
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import ReactGA from 'react-ga4';
import * as Sentry from '@sentry/react';

// project imports
import * as serviceWorker from './serviceWorker';
import App from 'App';
import { store } from 'store';

// style + assets
import 'assets/scss/style.scss';
if (process.env.REACT_APP_GA_CODE) {
    ReactGA.initialize(process.env.REACT_APP_GA_CODE);
}

if (process.env.REACT_APP_WEB_ENV === 'production') {
    const clarityScript = document.createElement('script');
    clarityScript.type = 'text/javascript';
    clarityScript.text = `
    (function(c,l,a,r,i,t,y){
      c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
      t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
      y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "seo9w9tph7");
  `;
    document.head.appendChild(clarityScript);

    Sentry.init({
        dsn: 'https://33567149266a2e072dedcbc4cc91c650@o1084453.ingest.us.sentry.io/4509507491528704',
        sendDefaultPii: true
    });
}

// ==============================|| REACT DOM RENDER  ||============================== //

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
    <Provider store={store}>
        <BrowserRouter basename="">
            <App />
        </BrowserRouter>
    </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
